import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-f-print",
  "use": "icon-f-print-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-f-print\">\n  <defs>\n    <style>\n      #icon-f-print .cls-1 {\n        fill: #5f6d84;\n        fill-rule: evenodd;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M3,0H21a3,3,0,0,1,3,3V21a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0ZM5,13v5a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1V13ZM6.88,5a1,1,0,0,0-1,.88L5,13H19l-.89-7.12a1,1,0,0,0-1-.88ZM8,15h8a1,1,0,1,1,0,2H8a1,1,0,1,1,0-2Z\" transform=\"translate(0)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol